import { AxiosPromise } from "axios";
import { apiWrapper } from "../../axiosInstance";
import { GeoCalculationsByIdsServiceResponse } from "./geoCalculationsByIds.service";

export const geoCalculationsByIdsEndpoint = (params: string): AxiosPromise<GeoCalculationsByIdsServiceResponse> =>
    apiWrapper.instance!.get(`rest/sdo/geoCalculationsByIds?${params}`);
